import styled from 'styled-components'

export const StyledHits = styled.div`
  transform: ${({ open }) => (open ? 'opacity(0)' : 'opacity(1)')};
`
